import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    Code: { label: i18n.t('app.code'), value: '' },
    Name: { label: i18n.t('app.name'), value: '' },
    Role: { label: i18n.tc('app.role', 1), value: '' },
  }
}

const getColumns = function getColumns () {
  return [
    { field: 'Code', title: i18n.t('app.code'), columnMenu: 'myTemplate', locked: false },
    { field: 'Name', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'Role', title: i18n.tc('app.role', 1), format: 'TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'IdAdministrativeCentreFACeB2B', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
  ]
}

const getDefaultState = () => {
  return {
    notificationsNumber: {},
  }
}
const customState = getDefaultState()
const customGetters = {
  getNotificationsNumber: state => state.notificationsNumber,
}
const customMutations = {
  setNotificationsNumber (state, notificationsNumber) {
    state.notificationsNumber = notificationsNumber
  },
  resetNotificationsNumber (state) {
    state.notificationsNumber = {}
  },
}

const mystore = parent({ customState, customGetters, customMutations, selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
